import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';
import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import { Button } from '@eliadmin/core/src/components/ui/button';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export const MethodicCard = ({ methodic, index }: { methodic: any; index: number }) => {
  return (
    <div className={cn('', index % 2 === 0 ? 'ea-methodic-card' : 'ea-methodic-card--reversed')}>
      <div className={cn('', 'ea-methodic-card__content')}>
        <span>0{index + 1}.</span>
        <div className={cn('', 'ea-methodic-card__text')}>
          <h3>{methodic.name}</h3>
          <Button asChild>
            <Link href={`/${methodic.slug}`} prefetch={false}>
              Dozvedieť sa viac
            </Link>
          </Button>
        </div>
      </div>
      <div className={cn('', 'ea-methodic-card__image-box')}>
        <Image
          src={methodic.image.url}
          alt={resolveImageAlt(methodic?.image, methodic?.name)}
          fill
          style={{ objectFit: 'contain', objectPosition: 'center' }}
          sizes="(max-width: 768px) 100vw, 50vw"
        />
      </div>
    </div>
  );
};
